
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageSquare, Mail } from "lucide-react";

const FeedbackManagement = () => {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-blue-500" />
            User Feedback & Support
          </CardTitle>
          <CardDescription>
            All user feedback, questions, and support requests are automatically forwarded to hassaanabegam@gmail.com
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8 text-muted-foreground">
            <Mail className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p className="font-medium">All feedback is automatically sent to:</p>
            <p className="text-lg text-blue-600 font-mono">hassaanabegam@gmail.com</p>
            <p className="text-sm mt-2">You'll receive notifications for:</p>
            <ul className="text-sm mt-2 space-y-1">
              <li>• User questions and doubts</li>
              <li>• Feature requests</li>
              <li>• Bug reports</li>
              <li>• General feedback</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default FeedbackManagement;
